import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";

import { makeStyles, Typography } from "@material-ui/core";

import { api } from "../../../../services/api";
import { POWER_ASSETS_COLORS } from "../../constants";
import { GRAPH_UNITS } from "../../../dashboard/constants";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { PieChart } from "../../../../components/charts/PieChart";
import { PieLegends } from "../../../../components/charts/PieLegends";
import { NoDataCard } from "../../../../components/parts";
import {
  requestDateFormat,
  capitalize,
  onlyUniqueValuesOfKeyInArray,
} from "../../../../services/utils";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
}));

export const ProductionTotal = ({ endpoint, period, startDate, endDate, graphUnit }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  const title = "Production - Total";

  useEffect(() => {
    if (rawData) {
      const formattedData = rawData.map((item) => ({
        name: capitalize(item.name),
        value: graphUnit === GRAPH_UNITS.kwh ? item.kwh_value : item.value,
        legendValue: graphUnit === GRAPH_UNITS.kwh ? item.kwh_value : item.value,
        displayValue: graphUnit === GRAPH_UNITS.kwh ? item.kwh_value : item.value,
        key: item.name,
      }));
      setData(formattedData);
    }
  }, [rawData, graphUnit]);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => {
        setRawData(resp.data.results);
      });
    };
    const getUrl = (period) => {
      let url = endpoint ? endpoint : "/praas/v1/power-assets/production/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
        getData(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getData(url);
      }
    };
    getUrl(period);
  }, [period, startDate, endDate, cluster, segments, selectedCountries]);

  const getData = useMemo(() => {
    return data.filter((val) => val.value);
  }, [data]);

  return (
    <ShaDowBox fullHeight>
      {rawData.length && !onlyUniqueValuesOfKeyInArray(rawData, "value", 0) ? (
        <div className={classes.box} id="production-total">
          <Typography variant="h4">{title}</Typography>
          <PieChart
            data={getData}
            colors={POWER_ASSETS_COLORS}
            name={graphUnit === GRAPH_UNITS.kwh ? "ProductionTotalKWH" : "ProductionTotal"}
            unit={graphUnit}
          />
          <PieLegends data={data} colors={POWER_ASSETS_COLORS} unit={graphUnit} />
        </div>
      ) : (
        <NoDataCard title={title} type="pie" />
      )}
    </ShaDowBox>
  );
};
